import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-12 mb-24" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["DashboardNavbar"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_Suspense, null, {
        fallback: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    ]),
    _createVNode($setup["TheFooterVue"])
  ], 64))
}